import Layout from "../../components/Layout";
import { DataKeluhan } from "../../data/DataKeluhan";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { keluhanBreadcrumb, defBreadcrumb } from "../../data/DataBreadcrumb";
import NextHead from "../../components/Seo/NextHead";
import { keluhanMeta } from "../../data/DataMetatags";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import Description from "../../components/UserInterface/Description";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";
import { StepsComponent } from "../../components/UserInterface/StepsComponent";
import { DownloadLink } from "../../components/UserInterface/DownloadLink";

const Keluhan = (props) => {
  const { breadcrumb, title, description, path } = props;
  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={keluhanBreadcrumb}></BreadcrumbComponent>
      <HeadingComponent headingText="Keluhan"></HeadingComponent>
      <LayoutCenter margin="0">
        <Description
          align="left"
          font="Roboto"
          text="Tujuan usaha kami adalah memberikan layanan pembiayaan kepada konsumen dengan Mudah, Sederhana dan Cepat. Kami menerima segala masukan dari Anda agar kami dapat terus  meningkatkan layanan kami untuk Anda.<br/><br/>Mohon berikan komentar Anda dengan melengkapi formulir dibawah ini."
        ></Description>
      </LayoutCenter>
      <LayoutCenter column>
        <StepsComponent
          marginRightappLeft
          hideImg="none"
          img="/static/images/svg/keluhan/illustration_complain_hotline.svg"
          title="1. Prosedur Singkat Layanan Keluhan Pelanggan"
        >
          <div className="container-link">
            <DownloadLink
              linkName="care@homecredit.co.id"
              url="mailto:care@homecredit.co.id"
              img="/static/images/svg/keluhan/ic_complain_email.svg"
            ></DownloadLink>
            <DownloadLink
              linkName="www.homecredit.co.id"
              url="https://www.homecredit.co.id/"
              img="/static/images/svg/keluhan/ic_complain_website.svg"
            ></DownloadLink>
            <DownloadLink
              linkName="021 2953 9600"
              url="tel:021-2953-9600"
              img="/static/images/svg/keluhan/ic_complain_phone.svg"
            ></DownloadLink>
          </div>
        </StepsComponent>
        <StepsComponent
          marginWeb="50px"
          marginMobile="10px"
          marginRightappLeft
          fontSteps="Roboto"
          hideImg="none"
          steps={DataKeluhan.howTo.steps}
          img="/static/images/svg/keluhan/illustration_complain_document.svg"
          title="2. Dokumen Yang Dibutuhkan"
        ></StepsComponent>
        <StepsComponent
          marginWeb="50px"
          marginMobile="10px"
          marginRightappLeft
          fontSteps="Roboto"
          subtitle="Layanan Pelanggan akan menganalisa keluhan, lalu merumuskan penyelesaian atau solusi yang dapat diberikan."
          img="/static/images/svg/keluhan/illustration_complain_handling.svg"
          hideImg="none"
          title="3. Penanganan Keluhan Pelanggan"
        ></StepsComponent>
        <StepsComponent
          marginWeb="50px"
          marginMobile="10px"
          marginRightappLeft
          fontSteps="Roboto"
          subtitle="Tanggapan terhadap keluhan akan disampaikan secara lisan atau tertulis dalam jangka waktu yang sesuai dengan peraturan yang berlaku."
          img="/static/images/svg/keluhan/ic_complain_waiting.svg"
          hideImg="none"
          title="4. Jangka Waktu Penyelesaian Keluhan Pelanggan"
        ></StepsComponent>
        <DownloadLink
          img="/static/images/svg/download-icon.svg"
          linkName="Publikasi Penanganan Pengaduan 2022"
          url="/static/pdf/Publikasi_Penanganan_Pengaduan_2022.pdf"
        />
        <DownloadLink
          img="/static/images/svg/download-icon.svg"
          linkName="Publikasi Penanganan Pengaduan 2021"
          url="/static/pdf/Publikasi_Penanganan_Pengaduan_2021.pdf"
        />
        <DownloadLink
          img="/static/images/svg/download-icon.svg"
          linkName="Publikasi Penanganan Pengaduan 2020"
          url="/static/pdf/Publikasi_Penanganan_Pengaduan_2020.pdf"
        />
        <DownloadLink
          img="/static/images/svg/download-icon.svg"
          linkName="Publikasi Penanganan Pengaduan 2019"
          url="/static/pdf/Publikasi_Penanganan_Pengaduan.pdf"
        />
        <DownloadLink
          img="/static/images/svg/download-icon.svg"
          linkName="Lembaga Alternatif Penyelesaian Sengketa Sektor Jasa Keuangan (LAPS SJK)"
          url="/info/lapssjk"
          target="_self"
        />
        <br />
      </LayoutCenter>
      <style jsx>{`
        .container-link {
          grid-column-gap: 10px;
          display: grid;
          grid-template-rows: 1fr 1fr 1fr;
          grid-auto-flow: column;
        }
        @media only screen and (max-width: 630px) {
          .container-link {
            display: inline;
          }
        }
      `}</style>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = keluhanMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseURL + path,
        name: title
      }
    }
  ];
  return { props: { breadcrumb, title, description, path } };
};

export default Keluhan;
